/* eslint-disable react/require-default-props */
import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { pathOr } from 'ramda'

import { hooks } from '@digital-commerce/shared-utils'
import locale from '../../../../contexts/Locale'
import { getMonthlyBillAmount } from '../utils'
import { MultipleLineItemNewDesign, PadContentLeft } from '../styles'
import InstallationFee from './components/InstallationFee'
import useHsMonthlyBillTranslations from './hooks/useHsMontlhyBillTranslations'
import OnlineOrderCredit from './components/OnlineOrderCredit'
import FirstBillSection from './components/FirstBillSection'
import MonthlyBill from './components/MonthlyBill'

const HSMonthlyBill = ({ totalPrice, cart, isAuthenticated, dataTestId, isHsOnly = true }) => {
  console.log('HSMonthlyBill rendered', dataTestId) // eslint-disable-line no-console
  const { lang } = React.useContext(locale)
  const { isIrpcFlow } = hooks.useIRPCParams()
  const translations = useHsMonthlyBillTranslations(cart)

  const { recurring } = totalPrice

  const recurringCredit = pathOr(0, [0, 'recurringCreditBreakdowns', 0, 'credit'])(recurring)

  const shouldHideOnlineCredit = !isHsOnly
  const shouldHideFirstBill = !isHsOnly

  return (
    <>
      <MultipleLineItemNewDesign>
        <MonthlyBill
          recurring={recurring}
          translations={translations}
          lang={lang}
          dataTestId={dataTestId}
          isAuthenticated={isAuthenticated}
          isIrpcFlow={isIrpcFlow}
        />
        <PadContentLeft>
          <InstallationFee
            cart={cart}
            translations={translations}
            lang={lang}
            dataTestId={dataTestId}
          />
          <OnlineOrderCredit
            translations={translations}
            dataTestId={dataTestId}
            hide={shouldHideOnlineCredit}
            recurringCredit={recurringCredit}
            lang={lang}
          />
        </PadContentLeft>
      </MultipleLineItemNewDesign>
      <FirstBillSection
        translations={translations}
        lang={lang}
        dataTestId={dataTestId}
        hide={shouldHideFirstBill}
        recurring={recurring}
        recurringCredit={recurringCredit}
        totalPrice={totalPrice}
        monthlyBillAmount={getMonthlyBillAmount(recurring, isIrpcFlow)}
        isAuthenticated={isAuthenticated}
      />
    </>
  )
}

HSMonthlyBill.propTypes = {
  totalPrice: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  dataTestId: PropTypes.string.isRequired,
  isHsOnly: PropTypes.bool
}

export default memo(HSMonthlyBill)
